<section class="campaign-detail-page">

    @if (isLoading) {
      <div class="loading-state">
        <p>Cargando campaña...</p>
      </div>
    }
  
    @if (!isLoading && campaign) {
  
      <div class="campaign-detail-header">
  
        <button
          type="button"
          class="back-button"
          (click)="goBack()"
        >
          ← Volver a campañas
        </button>
  
        <div class="campaign-title-section">
  
          <div>
            <h1>{{ campaign.petName }}</h1>
  
            <p>
              Responsable: {{ campaign.responsibleName }}
            </p>
          </div>
  
          <span
            class="species-badge"
            [class.cat-badge]="campaign.species === 'CAT'"
          >
            {{ campaign.species === 'DOG' ? 'Perro' : 'Gato' }}
          </span>
  
        </div>
  
      </div>
  
      <div class="campaign-summary">
  
        <div class="summary-item">
          <span>Fecha de esterilización</span>
  
          <strong>
            {{
              campaign.sterilizationDate
                ? (campaign.sterilizationDate | date:'mediumDate':'UTC')
                : '—'
            }}
          </strong>
        </div>
  
        <div class="summary-item">
          <span>Tipo de campaña</span>
  
          <strong>
            {{ campaign.campaignType || '—' }}
          </strong>
        </div>
  
        <div class="summary-item">
          <span>Ubicación</span>
  
          <strong>
            {{ campaign.sterilizationLocation || '—' }}
          </strong>
        </div>
  
        <div class="summary-item">
          <span>Veterinario</span>
  
          <strong>
            {{ campaign.veterinarian || '—' }}
          </strong>
        </div>
  
      </div>
  
      <div class="campaign-sections">
  
        <section class="detail-section">
  
          <div class="section-header">
            <h2>Información de la mascota</h2>
          </div>
  
          <div class="detail-grid">
  
            <div class="detail-item">
              <span>Nombre</span>
              <strong>{{ campaign.petName }}</strong>
            </div>
  
            <div class="detail-item">
              <span>Especie</span>
              <strong>
                {{ campaign.species === 'DOG' ? 'Perro' : 'Gato' }}
              </strong>
            </div>
  
            <div class="detail-item">
              <span>Sexo</span>
              <strong>{{ campaign.petGender || '—' }}</strong>
            </div>
  
            <div class="detail-item">
              <span>Raza</span>
              <strong>{{ campaign.breed || '—' }}</strong>
            </div>
  
            <div class="detail-item">
              <span>Tamaño</span>
              <strong>{{ campaign.size || '—' }}</strong>
            </div>
  
            <div class="detail-item">
              <span>Edad</span>
              <strong>
                {{ campaign.petAge ?? '—' }}
                @if (campaign.petAge !== null && campaign.petAge !== undefined) {
                  años
                }
              </strong>
            </div>
  
            <div class="detail-item">
              <span>Peso</span>
              <strong>
                {{ campaign.weight ?? '—' }}
                @if (campaign.weight !== null && campaign.weight !== undefined) {
                  kg
                }
              </strong>
            </div>
  
          </div>
  
        </section>
  
        <section class="detail-section">
  
          <div class="section-header">
            <h2>Información del responsable</h2>
          </div>
  
          <div class="detail-grid">
  
            <div class="detail-item">
              <span>Nombre</span>
              <strong>{{ campaign.responsibleName }}</strong>
            </div>
  
            <div class="detail-item">
              <span>Edad</span>
              <strong>
                {{ campaign.responsibleAge ?? '—' }}
                @if (
                  campaign.responsibleAge !== null &&
                  campaign.responsibleAge !== undefined
                ) {
                  años
                }
              </strong>
            </div>
  
            <div class="detail-item">
              <span>Sexo</span>
              <strong>{{ campaign.responsibleGender || '—' }}</strong>
            </div>
  
            <div class="detail-item">
              <span>Correo</span>
              <strong>{{ campaign.email || '—' }}</strong>
            </div>
  
            <div class="detail-item">
              <span>Teléfono</span>
              <strong>{{ campaign.phone || '—' }}</strong>
            </div>
  
            <div class="detail-item">
              <span>Municipio</span>
              <strong>{{ campaign.municipality || '—' }}</strong>
            </div>
  
            <div class="detail-item">
              <span>Colonia</span>
              <strong>{{ campaign.neighborhood || '—' }}</strong>
            </div>
  
            <div class="detail-item">
              <span>Calle</span>
              <strong>{{ campaign.street || '—' }}</strong>
            </div>
  
          </div>
  
        </section>
  
        <section class="detail-section">
  
          <div class="section-header">
            <h2>Información de ABAQ</h2>
          </div>
  
          <div class="detail-grid">
  
            <div class="detail-item">
              <span>Forma de pago</span>
              <strong>{{ campaign.payment || '—' }}</strong>
            </div>
  
            <div class="detail-item">
              <span>Cómo conoció ABAQ</span>
              <strong>
                {{ campaign.howDidYouHearAboutAbaq || '—' }}
              </strong>
            </div>
  
            <div class="detail-item">
              <span>Red social</span>
              <strong>{{ campaign.socialNetwork || '—' }}</strong>
            </div>
  
            <div class="detail-item">
              <span>Cuenta social</span>
              <strong>{{ campaign.socialAccount || '—' }}</strong>
            </div>
  
            <div class="detail-item">
              <span>Recomendó ABAQ en redes</span>
              <strong>
                {{ campaign.recommendedAbaqOnSocialMedia ? 'Sí' : 'No' }}
              </strong>
            </div>
  
          </div>
  
        </section>
  
        <section class="detail-section">
  
          <div class="section-header">
            <h2>Información de la atención</h2>
          </div>
  
          <div class="detail-grid">
  
            <div class="detail-item">
              <span>Fecha de esterilización</span>
              <strong>
                {{
                  campaign.sterilizationDate
                    ? (campaign.sterilizationDate | date:'mediumDate':'UTC')
                    : '—'
                }}
              </strong>
            </div>
  
            <div class="detail-item">
              <span>Lugar de esterilización</span>
              <strong>
                {{ campaign.sterilizationLocation || '—' }}
              </strong>
            </div>
  
            <div class="detail-item">
              <span>Tipo de campaña</span>
              <strong>
                {{ campaign.campaignType || '—' }}
              </strong>
            </div>
  
            <div class="detail-item">
              <span>Veterinario</span>
              <strong>
                {{ campaign.veterinarian || '—' }}
              </strong>
            </div>
  
          </div>
  
          @if (campaign.comments) {
            <div class="comments-block">
              <span>Comentarios</span>
              <p>{{ campaign.comments }}</p>
            </div>
          }
  
        </section>
  
      </div>
  
    }
  
    @if (!isLoading && !campaign) {
  
      <div class="empty-state">
  
        <p>
          No se pudo encontrar la campaña.
        </p>
  
        <button
          type="button"
          class="back-button"
          (click)="goBack()"
        >
          Volver a campañas
        </button>
  
      </div>
  
    }
  
  </section>